import { SoapUtils } from "../../../utils/SoapUtils";
import { toGarantXml } from "./EventItem";

export interface TaskItem {
    aclh?:                    string;
    activityId?:              string;
    activityName?:            string;
    activityRefId?:           string;
    actualHours?:             string;
    addDuration?:             string;
    chargeable?:              string;
    color?:                   string;
    comments?:                string;
    commonId?:                string;
    completed?:               string;
    compold?:                 string;
    contactsChanged?:         string;
    cost?:                    string;
    created?:                 string;
    createdBy?:               string;
    createdByName?:           string;
    customId?:                string;
    dateFrom?:                string;
    dateTo?:                  string;
    description?:             string;
    developmentStatus?:       string;
    dimension1?:              string;
    dimension1Name?:          string;
    dimension2?:              string;
    dimension2Name?:          string;
    dimension3?:              string;
    dimension3Name?:          string;
    distributionHandle?:      string;
    enteredId?:               string;
    entryType?:               string;
    entryTypeName?:           string;
    estimationHours?:         string;
    folderId?:                string;
    folderName?:              string;
    folderRefId?:             string;
    forUser?:                 string;
    headId?:                  string;
    headUserId?:              string;
    htmlText?:                string;
    ident?:                   string;
    isIssue?:                 string;
    isMultiUser?:             string;
    isPrivate?:               string;
    isTask?:                  string;
    iversion?:                string;
    location?:                string;
    masterMultiEventTask?:    string;
    milestones?:              string;
    modified?:                string;
    modifiedByName?:          string;
    multiChange?:             string;
    multiEventTask?:          string;
    nodeId?:                  string;
    notify?:                  string;
    plannedTaskCurrent?:      string;
    postChecklistForm?:       string;
    postChecklistFormName?:   string;
    postChecklistFormValues?: string;
    preChecklistForm?:        string;
    preChecklistFormName?:    string;
    preChecklistFormValues?:  string;
    priority?:                string;
    projectId?:               string;
    refId?:                   string;
    remainingHours?:          string;
    reminder?:                string;
    reminderTime?:            string;
    remoteHeadId?:            string;
    remoteId?:                string;
    resourceId?:              string;
    revenue?:                 string;
    severity?:                string;
    solutionStatus?:          string;
    status?:                  string;
    taskTemplateId?:          string;
    timeTracker?:             string;
    title?:                   string;
    userId?:                  string;
    userName?:                string;
    workRecord?:              string;
    workRequest?:             string;
    
    CONTACT?:                 Contact;
    DEPEND?:                  Depend;
    DOCUMENT?:                Document | Document[];
    GARANT?:                  Garant[];
    REPEAT?:                  Repeat;
    RESOURCE?:                Resource;
    USER?:                    Contact;
}

export interface Contact {
    id?: string;
}

export interface Depend {
    ident?: string;
    title?: string;
    type?:  string;
}

export interface Document {
    documentId?: string;
    name?:       string;
}

export interface Garant {
    userId?: string;
}

export interface Repeat {
    repeatMode?:        string;
    validFrom?:         string;
    validTo?:           string;
    repeatEvery?:       string;
    repeatDay?:         string;
    repeatMonth?:       string;
    repeatWeekDay?:     string;
    repeatWeekCount?:   string;
    repeatWeekDayList?: string;
    timeFrom?:          string;
    timeTo?:            string;
    useOffset?:         string;
    offset?:            string;
    limit?:             string;
    user?:              string;
}

export interface Resource {
    id?:           string;
    name?:         string;
    description?:  string;
    categoryId?:   string;
    needApproval?: string;
}

export function toTaskItemXML(item:TaskItem): string{
    var parameters = '';

    parameters += SoapUtils.makeNode(item.aclh, 'aclh');
    parameters += SoapUtils.makeNode(item.activityId, 'activityId');
    parameters += SoapUtils.makeNode(item.activityName, 'activityName');
    parameters += SoapUtils.makeNode(item.activityRefId, 'activityRefId');
    parameters += SoapUtils.makeNode(item.actualHours, 'actualHours');
    parameters += SoapUtils.makeNode(item.addDuration, 'addDuration');
    parameters += SoapUtils.makeNode(item.chargeable, 'chargeable');
    parameters += SoapUtils.makeNode(item.color, 'color');
    parameters += SoapUtils.makeNode(item.comments, 'comments');
    parameters += SoapUtils.makeNode(item.commonId, 'commonId');
    parameters += SoapUtils.makeNode(item.completed, 'completed');
    parameters += SoapUtils.makeNode(item.compold, 'compold');
    parameters += SoapUtils.makeNode(item.contactsChanged, 'contactsChanged');
    parameters += SoapUtils.makeNode(item.cost, 'cost');
    parameters += SoapUtils.makeNode(item.created, 'created');
    parameters += SoapUtils.makeNode(item.createdBy, 'createdBy');
    parameters += SoapUtils.makeNode(item.createdByName, 'createdByName');
    parameters += SoapUtils.makeNode(item.customId, 'customId');
    parameters += SoapUtils.makeNode(item.dateFrom, 'dateFrom');
    parameters += SoapUtils.makeNode(item.dateTo, 'dateTo');
    parameters += SoapUtils.makeNode(item.description, 'description');
    parameters += SoapUtils.makeNode(item.developmentStatus, 'developmentStatus');
    parameters += SoapUtils.makeNode(item.dimension1, 'dimension1');
    parameters += SoapUtils.makeNode(item.dimension1Name, 'dimension1Name');
    parameters += SoapUtils.makeNode(item.dimension2, 'dimension2');
    parameters += SoapUtils.makeNode(item.dimension2Name, 'dimension2Name');
    parameters += SoapUtils.makeNode(item.dimension3, 'dimension3');
    parameters += SoapUtils.makeNode(item.dimension3Name, 'dimension3Name');
    parameters += SoapUtils.makeNode(item.distributionHandle, 'distributionHandle');
    parameters += SoapUtils.makeNode(item.enteredId, 'enteredId');
    parameters += SoapUtils.makeNode(item.entryType, 'entryType');
    parameters += SoapUtils.makeNode(item.entryTypeName, 'entryTypeName');
    parameters += SoapUtils.makeNode(item.estimationHours, 'estimationHours');
    parameters += SoapUtils.makeNode(item.folderId, 'folderId');
    parameters += SoapUtils.makeNode(item.folderName, 'folderName');
    parameters += SoapUtils.makeNode(item.folderRefId, 'folderRefId');
    parameters += SoapUtils.makeNode(item.forUser, 'forUser');
    parameters += SoapUtils.makeNode(item.headId, 'headId');
    parameters += SoapUtils.makeNode(item.headUserId, 'headUserId');
    parameters += SoapUtils.makeNode(item.htmlText, 'htmlText');
    parameters += SoapUtils.makeNode(item.ident, 'ident');
    parameters += SoapUtils.makeNode(item.isIssue, 'isIssue');
    parameters += SoapUtils.makeNode(item.isMultiUser, 'isMultiUser');
    parameters += SoapUtils.makeNode(item.isPrivate, 'isPrivate');
    parameters += SoapUtils.makeNode(item.iversion, 'iversion');
    parameters += SoapUtils.makeNode(item.location, 'location');
    parameters += SoapUtils.makeNode(item.masterMultiEventTask, 'masterMultiEventTask');
    parameters += SoapUtils.makeNode(item.milestones, 'milestones');
    parameters += SoapUtils.makeNode(item.modified, 'modified');
    parameters += SoapUtils.makeNode(item.modifiedByName, 'modifiedByName');
    parameters += SoapUtils.makeNode(item.multiChange, 'multiChange');
    parameters += SoapUtils.makeNode(item.multiEventTask, 'multiEventTask');
    parameters += SoapUtils.makeNode(item.nodeId, 'nodeId');
    parameters += SoapUtils.makeNode(item.notify, 'notify');
    parameters += SoapUtils.makeNode(item.plannedTaskCurrent, 'plannedTaskCurrent');
    parameters += SoapUtils.makeNode(item.postChecklistForm, 'postChecklistForm');
    parameters += SoapUtils.makeNode(item.postChecklistFormName, 'postChecklistFormName');
    parameters += SoapUtils.makeNode(item.postChecklistFormValues, 'postChecklistFormValues');
    parameters += SoapUtils.makeNode(item.preChecklistForm, 'preChecklistForm');
    parameters += SoapUtils.makeNode(item.preChecklistFormName, 'preChecklistFormName');
    parameters += SoapUtils.makeNode(item.preChecklistFormValues, 'preChecklistFormValues');
    parameters += SoapUtils.makeNode(item.priority, 'priority');
    parameters += SoapUtils.makeNode(item.projectId, 'projectId');
    parameters += SoapUtils.makeNode(item.refId, 'refId');
    parameters += SoapUtils.makeNode(item.remainingHours, 'remainingHours');
    parameters += SoapUtils.makeNode(item.reminder, 'reminder');
    parameters += SoapUtils.makeNode(item.reminderTime, 'reminderTime');
    parameters += SoapUtils.makeNode(item.remoteHeadId, 'remoteHeadId');
    parameters += SoapUtils.makeNode(item.remoteId, 'remoteId');
    parameters += SoapUtils.makeNode(item.resourceId, 'resourceId');
    parameters += SoapUtils.makeNode(item.severity, 'severity');
    parameters += SoapUtils.makeNode(item.solutionStatus, 'solutionStatus');
    parameters += SoapUtils.makeNode(item.status, 'status');
    parameters += SoapUtils.makeNode(item.taskTemplateId, 'taskTemplateId');
    parameters += SoapUtils.makeNode(item.timeTracker, 'timeTracker');
    parameters += SoapUtils.makeNode(item.title, 'title');
    parameters += SoapUtils.makeNode(item.userId, 'userId');
    parameters += SoapUtils.makeNode(item.userName, 'userName');
    parameters += SoapUtils.makeNode(item.workRecord, 'workRecord');
    parameters += SoapUtils.makeNode(item.workRequest, 'workRequest');
    
    if(item.CONTACT) parameters += `<CONTACT>${SoapUtils.makeNode(item.CONTACT.id, 'id')}</CONTACT>`;
    if(item.DOCUMENT) {
        const documents = Array.isArray(item.DOCUMENT) ? item.DOCUMENT : [item.DOCUMENT];
        parameters += documents
            .filter((document) => document && (document.documentId || document.name))
            .map((document) => `<DOCUMENT>${SoapUtils.makeNode(document.documentId, 'documentId')}${SoapUtils.makeNode(document.name, 'name')}</DOCUMENT>`)
            .join('');
    }
    if(item.DEPEND) parameters += `<DEPEND>${SoapUtils.makeNode(item.DEPEND.ident, 'ident')}${SoapUtils.makeNode(item.DEPEND.title, 'title')}${SoapUtils.makeNode(item.DEPEND.type, 'type')}</DEPEND>`;
    if(item.GARANT) parameters += SoapUtils.makeNodeArray(item.GARANT, toGarantXml);
    if(item.REPEAT) parameters += `<REPEAT>${SoapUtils.makeNode(item.REPEAT.repeatMode, 'repeatMode')}${SoapUtils.makeNode(item.REPEAT.validFrom, 'validFrom')}${SoapUtils.makeNode(item.REPEAT.validTo, 'validTo')}${SoapUtils.makeNode(item.REPEAT.repeatEvery, 'repeatEvery')}${SoapUtils.makeNode(item.REPEAT.repeatDay, 'repeatDay')}${SoapUtils.makeNode(item.REPEAT.repeatMonth, 'repeatMonth')}${SoapUtils.makeNode(item.REPEAT.repeatWeekDay, 'repeatWeekDay')}${SoapUtils.makeNode(item.REPEAT.repeatWeekCount, 'repeatWeekCount')}${SoapUtils.makeNode(item.REPEAT.repeatWeekDayList, 'repeatWeekDayList')}${SoapUtils.makeNode(item.REPEAT.timeFrom, 'timeFrom')}${SoapUtils.makeNode(item.REPEAT.timeTo, 'timeTo')}${SoapUtils.makeNode(item.REPEAT.useOffset, 'useOffset')}${SoapUtils.makeNode(item.REPEAT.offset, 'offset')}${SoapUtils.makeNode(item.REPEAT.limit, 'limit')}${SoapUtils.makeNode(item.REPEAT.user, 'user')}</REPEAT>`;
    if(item.RESOURCE) parameters += `<RESOURCE>${SoapUtils.makeNode(item.RESOURCE.id, 'id')}${SoapUtils.makeNode(item.RESOURCE.name, 'name')}${SoapUtils.makeNode(item.RESOURCE.description, 'description')}${SoapUtils.makeNode(item.RESOURCE.categoryId, 'categoryId')}${SoapUtils.makeNode(item.RESOURCE.needApproval, 'needApproval')}</RESOURCE>`;
    if(item.USER) parameters += `<USER>${SoapUtils.makeNode(item.USER.id, 'id')}</USER>`;

    return parameters;
}
